import { useNavigate } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { scrollToSection } from "@/data/catalog";
import { Megaphone, Youtube, Music, TrendingUp, Target, ArrowUpRight } from "lucide-react";

const DISTROKID_URL = "https://distrokid.com/vip/seven/1175832";
const GOOGLE_ADS_URL = "https://business.google.com/us/google-ads/welcome-offer/?utm_source=ads-refer&utm_medium=refer-program&utm_campaign=sv-copylinkbutton";

const SERVICES = [
  { icon: Megaphone, title: "Social Media Marketing", desc: "Grow your following and engagement across all major platforms.", target: "#pricing", scroll: true },
  { icon: Youtube, title: "Video Promotion", desc: "Increase your views, watch time, and reach with high-impact campaigns.", target: "/services/youtube" },
  { icon: Music, title: "Music Promotion", desc: "Get your music heard on all major streaming platforms and beyond.", target: DISTROKID_URL, external: true },
  { icon: TrendingUp, title: "Brand Growth", desc: "Strategic marketing solutions designed to build your brand and drive real results.", target: "#strategy", scroll: true },
  { icon: Target, title: "Targeted Ad Campaigns", desc: "Precision-targeted ads that connect you with the right audience.", target: GOOGLE_ADS_URL, external: true },
];

export default function ServicesGrid() {
  const navigate = useNavigate();
  const go = (s) => {
    if (s.external) window.open(s.target, "_blank", "noopener,noreferrer");
    else if (s.scroll) scrollToSection(s.target);
    else navigate(s.target);
  };

  return (
    <section id="services" data-testid="services-section" className="relative border-t border-[#1F1F1F] bg-[#050505] py-24 lg:py-32">
      <div className="pointer-events-none absolute right-0 top-24 h-[380px] w-[380px] rounded-full bg-[#E11D2E]/[0.06] blur-[140px]" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#E11D2E]">Our services</p>
          <h2 className="mt-4 font-display text-4xl uppercase leading-[1.02] tracking-tight text-white sm:text-5xl">
            Powerful promotion.
            <span className="block text-[#E11D2E]">Real results.</span>
          </h2>
          <p className="mt-5 max-w-lg text-sm leading-relaxed text-[#8A8A8A] md:text-base">
            We offer a wide range of digital marketing services to boost your brand, grow your
            audience, and take your business to the next level.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08} data-testid={`service-card-${i}`}>
              <button
                onClick={() => go(s)}
                data-testid={`service-card-btn-${i}`}
                className="group flex h-full w-full flex-col border border-[#1F1F1F] bg-[#0D0D0D] p-6 text-left transition-all duration-500 hover:-translate-y-1 hover:border-[#E11D2E]/50 hover:shadow-[0_0_40px_rgba(225,29,46,0.12)]"
              >
                <s.icon size={26} className="text-[#E11D2E]" />
                <h3 className="mt-6 font-display text-base uppercase leading-snug tracking-wide text-white">
                  {s.title}
                </h3>
                <p className="mt-3 flex-1 text-xs leading-relaxed text-[#8A8A8A]">{s.desc}</p>
                <span className="mt-6 flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.18em] text-[#E11D2E]">
                  Learn more
                  <ArrowUpRight size={12} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
